export const readAffiliateFromLocalStorage = () => localStorage.getItem('@USER/AFFILIATE')
export const saveAffiliateFromToStorage = (at: string) =>
  localStorage.setItem('@USER/AFFILIATE', at)
export const delAffiliateFromLocalStorage = () => localStorage.removeItem('@USER/AFFILIATE')
